import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/shared/services/REST-API/rest.service';
import { MatDialog } from '@angular/material/dialog';
import { SquadDialogBoxComponent } from './squad-dialog-box/squad-dialog-box.component';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";


@Component({
  selector: 'app-events-page',
  templateUrl: './events-page.component.html',
  styleUrls: ['./events-page.component.css']
})
export class EventsPageComponent implements OnInit {
  acvtiveTab = 'eventDetails';
  userDetail;
  matchName;
  matchType;
  date;
  map;
  poolPrize;
  platform;
  maxPlayers;
  prizeBreakDown;
  registeredPlayers;
  participants;
  eventDetailFromService;
  allEventDetails = {
    data: [],
    activeIndex: 0
  }
  squadDetails: any;
  event_id: any;
  constructor(private authApi: AuthService,
    public dialog: MatDialog,
    private route: Router,
    private toastr: ToastrService,
    private router: ActivatedRoute,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.spinner.show();
    this.authApi.user.subscribe((data) => {
      this.userDetail = data;
    })
    this.router.queryParams.subscribe((data) => {
      if (data.event_id) {
        this.eventDetailFromService = JSON.parse(localStorage.getItem('eventDeatils'))
        this.matchName = this.eventDetailFromService.matchName;
        this.matchType = this.eventDetailFromService.matchType;
        this.date = this.eventDetailFromService.time;
        this.poolPrize = this.eventDetailFromService.poolPrize;
        this.maxPlayers = this.eventDetailFromService.maxPlayers;
        this.getEventDetails(data.event_id);

      } else {
        this.eventDetailFromService = undefined;
        this.authApi.eventList().subscribe((data) => {
          this.allEventDetails.data = data;
          this.setEventDetails()
        })
      }

    })

  }
  scrollRight() {
    this.spinner.show();
    this.allEventDetails.activeIndex = ++this.allEventDetails.activeIndex;
    this.setEventDetails();
  }

  scrollLeft() {
    this.spinner.show();
    this.allEventDetails.activeIndex = --this.allEventDetails.activeIndex;
    this.setEventDetails();
  }

  setEventDetails() {
    this.matchName = this.allEventDetails.data[this.allEventDetails.activeIndex].matchName;
    this.matchType = this.allEventDetails.data[this.allEventDetails.activeIndex].matchType;
    this.date = this.allEventDetails.data[this.allEventDetails.activeIndex].time;
    this.poolPrize = this.allEventDetails.data[this.allEventDetails.activeIndex].poolPrize;
    this.maxPlayers = this.allEventDetails.data[this.allEventDetails.activeIndex].maxPlayers;
    this.event_id = this.allEventDetails.data[this.allEventDetails.activeIndex]._id
    if (!this.allEventDetails[this.allEventDetails.data[this.allEventDetails.activeIndex]._id]) {
      this.getEventDetails(this.allEventDetails.data[this.allEventDetails.activeIndex]._id);
    } else {
      const details = this.allEventDetails[this.allEventDetails.data[this.allEventDetails.activeIndex]._id]
      this.map = details.map;
      this.platform = details.platform;
      this.participants = details.participants;
      this.squadDetails = details.squadDetails;
      this.prizeBreakDown = details.prizeBreakDown;
      this.registeredPlayers = details.registeredPlayers;
      this.spinner.hide();

    }
  }
  getEventDetails(event_id) {
    this.authApi.eventDetails(event_id).subscribe((details) => {
      this.allEventDetails[event_id] = details
      this.map = details.map;
      this.platform = details.platform;
      this.participants = details.participants;
      this.squadDetails = details.squadDetails;
      this.prizeBreakDown = details.prizeBreakDown;
      this.registeredPlayers = details.registeredPlayers;
      this.spinner.hide();
    })
  }
  onEventJoining() {
    if (this.userDetail) {
      if (this.matchType.toUpperCase() == 'SQUAD') {
        this.joinSquadEvent();
      } else if (this.matchType.toUpperCase() == 'SOLO') {
        this.joinSoloEvent();

      }
    } else {
      this.route.navigate(['/auth'], { queryParams: { event_id: this.eventDetailFromService?._id?this.eventDetailFromService._id:this.event_id } })
    }
  }

  joinSoloEvent() {
    const participants = {
      user_id: this.userDetail._id,
      userName: this.userDetail.userName
    }
    if (true) {
      this.authApi.registerUserForEvent(this.eventDetailFromService?._id?this.eventDetailFromService._id:this.event_id, { participants }).subscribe((data) => {
        this.toastr.success("Registered successfully", "Kudos Gammer");
        this.ngOnInit();
      })
    }
  }

  joinSquadEvent() {
    this.openDialog(null)
  }

  openDialog(value): void {
    const dialogRef = this.dialog.open(SquadDialogBoxComponent, {
      data: { data: value }
    },);

    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

  onClickTab(tabName) {
    this.acvtiveTab = tabName;
  }

  squadMemberSetting(squad) {
    this.openDialog(squad)
  }

}

